import React from "react";
import { useLang } from "@/lib/useLang";

function formatDate(iso, lang) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(lang === "ml" ? "ml-IN" : "en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

/**
 * Big "Official Announcement" card shown at the top of the frozen state.
 * Shows the announced CM's photo (if provided) + name + date.
 */
export const FrozenAnnouncement = ({ pollState }) => {
  const { t, lang } = useLang();
  if (!pollState?.frozen) return null;

  const name = pollState.announced_cm_name || "—";
  const photo = pollState.announced_cm_photo || "";
  const announcedAt = formatDate(pollState.announced_at, lang);

  return (
    <section
      className="brutal-card p-6 md:p-10 fade-up"
      style={{ background: "#0A0A0A", color: "#FDFBF7" }}
      data-testid="frozen-announcement-card"
    >
      <p
        className="text-xs md:text-sm uppercase font-bold tracking-[0.4em] mb-4"
        style={{ color: "#FF9933" }}
        data-testid="announcement-eyebrow"
      >
        {t("announcement_eyebrow")}
      </p>

      <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
        {photo ? (
          <div
            className="border-4 border-black overflow-hidden shrink-0"
            style={{ width: 180, height: 180, background: "#FF9933" }}
            data-testid="announcement-photo"
          >
            <img
              src={photo}
              alt={name}
              crossOrigin="anonymous"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "50% 18%",
              }}
            />
          </div>
        ) : null}

        <div className="flex-1 min-w-0">
          <p
            className="text-xs md:text-sm uppercase font-bold tracking-[0.3em] mb-3"
            style={{ color: "#FDFBF7", opacity: 0.7 }}
            data-testid="announcement-label"
          >
            {t("announcement_label")}
          </p>
          <h2
            className="font-display uppercase leading-[0.9] tracking-tight break-words"
            style={{ fontSize: "clamp(2.5rem, 7vw, 5.5rem)", color: "#FDFBF7" }}
            data-testid="announcement-cm-name"
          >
            {name}
          </h2>
          {announcedAt && (
            <p
              className="mt-4 text-sm md:text-base uppercase font-bold tracking-[0.25em]"
              style={{ color: "#FF9933" }}
              data-testid="announcement-date"
            >
              {t("announced_on")}: {announcedAt}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default FrozenAnnouncement;
